import { render, staticRenderFns } from "./EducationSettings.vue?vue&type=template&id=22473bad&scoped=true&"
import script from "./EducationSettings.vue?vue&type=script&lang=js&"
export * from "./EducationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22473bad",
  null
  
)

export default component.exports